export enum VenueInvoiceType {
  PROVISION_INVOICE = 'venue.invoice.provision.invoice',
  PRINTER_PREMIUM = 'venue.invoice.printer.premium',
  SETUP_FEE_99 = 'venue.invoice.setup.fee.99',
  SETUP_FEE_49 = 'venue.invoice.setup.fee.49',
}
